import React, {useState} from "react";
import {Button, ButtonToolbar, Container, Content, FlexboxGrid, Form, Header, Navbar, Panel} from "rsuite";
import googleButton from '../../img/btn_google_signin_dark_normal_web.png'

const headerCss = {
    backgroundColor: "#3CB7EA",
    display: 'flex',
    fontSize: '20px',
    height: '60px'
};

const Login = () => {
    // stubbed this out with the below login form for eventual ldap login with syn credentials
    // eslint-disable-next-line no-unused-vars
    const [ldapLoginEnabled, setLdapLoginEnabled] = useState(false);
    return (
        <Container>
            <Header>
                <Navbar appearance="inverse" style={{backgroundColor: "#3CB7EA", flex: 1, display: 'flex', marginBottom: '0.5rem'}}>
                    <Navbar.Brand href="https://synergistcomputing.com" target="_blank" style={headerCss}>
                        Synergist Computing
                    </Navbar.Brand>
                </Navbar>
            </Header>
            <Content>
                <FlexboxGrid justify="center">
                    {ldapLoginEnabled ?
                    <FlexboxGrid.Item colspan={12}>
                        <Panel header={<h3>Login</h3>} bordered>
                            <Form fluid>
                                <Form.Group>
                                    <Form.ControlLabel>Username or email address</Form.ControlLabel>
                                    <Form.Control name="name" />
                                </Form.Group>
                                <Form.Group>
                                    <Form.ControlLabel>Password</Form.ControlLabel>
                                    <Form.Control name="password" type="password" autoComplete="off" />
                                </Form.Group>
                                <Form.Group>
                                    <ButtonToolbar>
                                        <Button appearance="primary">Sign in</Button>
                                    </ButtonToolbar>
                                </Form.Group>
                            </Form>
                        </Panel>
                    </FlexboxGrid.Item> : null}
                    <FlexboxGrid.Item colspan={12}>
                        <Panel header={<h3>Synergist Resume Manager Login</h3>} bordered>
                            <a href="/oauth2/authorization/google"><img src={googleButton} alt="Google Login Button"/></a>
                        </Panel>
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </Content>
        </Container>
    );
}

export default Login;